import {
  ITypeFieldFilterOptions,
  OperatorType,
} from '~/client/graph/types.generated'

import { getAllowedFilterValues } from './getAllowedFilterValues'

export const resourceFilterPropMap = {
  TEMPLATE_ID: 'templateId',
} as const

export const isTemplateFilter = (filter: ITypeFieldFilterOptions): boolean =>
  filter.propertyPath === resourceFilterPropMap.TEMPLATE_ID

export function getAllowedTemplateIds(
  filterOptions: ITypeFieldFilterOptions[] | null | undefined,
): string[] {
  return getAllowedFilterValues(
    filterOptions,
    resourceFilterPropMap.TEMPLATE_ID,
  )
}

export function hasTemplateAllowListFilter(
  filterOptions: ITypeFieldFilterOptions[] | null | undefined,
): boolean {
  return !!filterOptions?.some(
    f =>
      f.propertyPath === resourceFilterPropMap.TEMPLATE_ID &&
      f.operator === OperatorType.In &&
      !f.fieldId,
  )
}
